import { RequestInputData } from "src/model/RequestInputData";
import { HeadCell } from "src/components/common/SortableTableHead";
import { CanonicalRepresentationRequestInputData } from "src/model/CanonicalRepresentationRequestInputData";
import { CanonicalRepresentationOutputItem } from "src/model/CanonicalRepresentationOutputItem";
import { FileStructure, downloadImagesAsZip, downloadTableDataAsCsvWithName } from "src/utils/DownloadUtilCommon";

export const downloadCapturesAsZip = async (itemCapturesData: any[], inputData: RequestInputData) => {
    const zipFileName = generateFileName(inputData, "zip");

    let subFileStructure: FileStructure = {};
    itemCapturesData.forEach((capture: any) => {
        // Create a folder for each capture in the zip object with capture id as folder name
        subFileStructure[capture.captureId] = <string[]> Object.values(capture.binaryFileLocations);
    });

    await downloadImagesAsZip(zipFileName, subFileStructure);
};

export const downloadCanonicalRepresentationsAsZip = async (
    outputData: CanonicalRepresentationOutputItem[],
    inputData: CanonicalRepresentationRequestInputData) => {

    const zipFileName = generateCanonicalRepresentationFileName(inputData, "zip");

    let subFileStructure: FileStructure = {};
    outputData.forEach((cirepItem: CanonicalRepresentationOutputItem) => {
        subFileStructure[cirepItem.uuid] = {
            images: cirepItem.imageLocations.map(imageLocation => imageLocation.canonicalImage),
            segmentationMasks: cirepItem.imageLocations.map(imageLocation => imageLocation.segmentationMask),
            metadata: [cirepItem.metadataLocation]
        };
    });

    await downloadImagesAsZip(zipFileName, subFileStructure);
}

export const downloadTableDataAsCsv = (dataRows: any[][], inputData: RequestInputData, columnHeads: Array<HeadCell>) => {
    downloadTableDataAsCsvWithName(dataRows, generateFileName(inputData, "csv"), columnHeads);
};

export const downloadCanonicalRepresentationTableDataAsCsv = (
    dataRows: any[][],
    inputData: CanonicalRepresentationRequestInputData,
    columnHeads: Array<HeadCell>) => {

    downloadTableDataAsCsvWithName(dataRows, generateCanonicalRepresentationFileName(inputData, "csv"), columnHeads);
}

const generateFileName = (inputData: RequestInputData, suffix: string): string => {
    const region = inputData.region;
    const hardwareSource = inputData.hardwareSource;
    const sensorType = inputData.sensorType;
    const itemId = inputData.itemId;

    return `IM_UI_${region}_${hardwareSource}_${sensorType}_${itemId}.${suffix}`;
};

const generateCanonicalRepresentationFileName =
    (inputData: CanonicalRepresentationRequestInputData, suffix: string): string => {

    const region = inputData.region;
    const hardwareSource = inputData.hardwareSource;
    const itemIdType = inputData.itemIdType;
    const itemId = inputData.itemId;
    const affinityThreshold = inputData.affinityThreshold;

    return `IM_CIREP_${region}_${hardwareSource}_${itemIdType}_${affinityThreshold}_${itemId}.${suffix}`;
}
